// userAgreement.js
export const USER_AGREEMENT = {
  lastUpdated: "April 2025",
  intro: `This Homeowner User Agreement ("Agreement") is a legal contract between you ("Homeowner", "you" or "your") and ShovelHouse Inc. ("Shovel House"). By using the Shovel House platform as a Homeowner, you agree to comply with and be bound by the terms and conditions of this Agreement.`,

  sections: [
    {
      title: "1. Overview",
      body: `ShovelHouse Inc. ("Shovel House") is a marketplace that connects homeowners ("Clients") with independent service providers ("Helpers" or "Neighbourhood Helpers") for snow shoveling, lawn mowing, and other outdoor services. Shovel House does not employ Helpers; they are independent users of the platform. Homeowners are also users of the platform and are not in an employment, partnership, or agency relationship with Shovel House or any Helpers.`,
    },
    {
      title: "2. Eligibility",
      list: [
        "Age Requirement: You must be at least 18 years old to use Shovel House as a Homeowner.",
        "Accuracy of Information: You agree that all information you provide is accurate, complete, and current.",
      ],
    },
    {
      title: "3. Use of the Platform",
      list: [
        "Posting Service Requests: You can post service requests with clear details, including service type, price, and any special instructions.",
        "Provision of Equipment: You must provide necessary equipment (e.g., shovels, lawn mower, salt) outside your property for Helpers to use.",
        "Equipment Safety and Responsibility: Homeowners are required to provide all necessary tools and equipment for the requested service. You are solely responsible for ensuring that this equipment is safe, functional, and suitable for its intended use. You must clearly communicate any operating instructions or precautions to the Helper. Shovel House and Helpers are not liable for injuries, damages, or failures caused by the use or condition of homeowner-provided equipment.",
        "No Illegal or Unsafe Requests: You agree not to request services that violate laws or pose safety risks.",
      ],
    },
    {
      title: "4. Payment and Pricing",
      list: [
        "Pricing: You can set your own price or request a volunteer. Paid job posts must clearly state the offered price.",
        "Payments: All payments must be processed through ShovelHouse Inc. (\"Shovel House\") using the platform’s payment methods. Platform service fees and third-party processing fees (e.g., Stripe) will be deducted from the amount you pay.",
        "Dispute Handling: Shovel House may hold payments in disputes until they are resolved.",
        "Platform and Payment Risks: Shovel House is not responsible for any disruptions, delays, errors, or failures in the platform or payment system. The platform is provided on an \"as-is\" basis.",
      ],
    },
    {
      title: "5. Interactions with Helpers",
      list: [
        "Independent Contractors: Helpers are independent contractors and not employees of Shovel House.",
        "Clear Instructions: Provide clear and complete instructions in your service requests.",
        "Service Quality: Shovel House does not guarantee the quality of services but encourages feedback and ratings.",
        "Non-Circumvention: You agree not to solicit Helpers for direct services outside the platform if the initial connection was made through Shovel House. This restriction applies during your time on the platform and for twelve (12) months after your last interaction with the Helper. Violations may result in removal from the platform and liability for lost platform fees.",
      ],
    },
    {
      title: "6. No-Contact Policy",
      list: [
        "Contactless Service: Shovel House promotes no-contact services. Avoid direct interaction with Helpers unless necessary.",
        "Communication: Use the platform’s messaging system for all communications to ensure safety.",
      ],
    },
    {
      title: "7. User Conduct and Account Standing",
      body: `You must conduct yourself respectfully and professionally when using the platform. Disrespectful behavior, harassment, or discrimination against Helpers or other users is grounds for removal. Repeated low ratings or complaints may result in account review, warning, or suspension.`,
    },
    {
      title: "8. Liability and Disclaimers",
      list: [
        "Assumption of Risk: You assume all risks associated with using services provided by independent Helpers.",
        "No Warranties: Shovel House makes no warranties about the services performed by Helpers.",
        "Damage or Loss: Shovel House is not liable for any property damage, loss, or personal injury resulting from the services provided by Helpers.",
      ],
    },
    {
      title: "9. Dispute Resolution",
      list: [
        "Reporting Disputes: Report any disputes through the Shovel House platform for assistance.",
        "Resolution Role: Shovel House facilitates communication between parties but is not obligated to mediate or resolve disputes. Shovel House may, at its sole discretion, review submitted documentation and issue a final decision, which will be considered final.",
        "Photo Documentation: In some cases, Shovel House may request before-and-after photos or other records to assist in resolving disputes.",
      ],
    },
    {
      title: "10. Privacy and Data Use",
      body: `By using the Shovel House platform, you consent to the collection, use, and storage of your personal information for the purposes of operating and improving the platform. Shovel House does not sell your personal data.`,
    },
    {
      title: "11. Termination",
      body: `Shovel House may suspend or terminate your account at its discretion for violations, harmful behavior, repeated poor feedback, or attempts to circumvent the platform, including arranging services with Helpers outside of Shovel House.`,
    },
    {
      title: "12. Modifications to the Agreement",
      body: `Shovel House may update this Agreement. Continued use of the platform indicates acceptance of the new terms. Material changes will be communicated via the platform or email where possible.`,
    },
    {
      title: "13. Right to Refuse Service",
      body: `Shovel House reserves the right to refuse access to the platform to any user, at any time, for any reason, including but not limited to violations of this Agreement.`,
    },
    {
      title: "14. Governing Law",
      body: `This Agreement is governed by the laws of the jurisdiction in which the Homeowner resides.`,
    },
    {
      title: "15. Acknowledgement",
      body: `By using the ShovelHouse Inc. ("Shovel House") platform, you acknowledge that you have read, understood, and agreed to be legally bound by the terms of this Agreement.`,
    },
  ],
};
